import { Linkedin, ArrowUpRight } from "lucide-react";
import { FadeUp } from "./Reveal";
import { TEAM } from "../../lib/site";

export default function Team() {
  return (
    <section id="team" className="relative py-24 lg:py-32" data-testid="team-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <FadeUp className="mb-16 max-w-2xl">
          <span className="font-body text-xs tracking-[0.35em] text-[#00D166]">THE PRACTICE</span>
          <h2 className="mt-4 font-display text-4xl md:text-6xl font-bold tracking-tight text-white">
            People behind <span className="font-serifed italic font-normal text-white/60">the placements.</span>
          </h2>
        </FadeUp>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {TEAM.map((m, i) => (
            <FadeUp key={m.name} delay={i * 0.08}>
              <a
                href={m.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`team-member-${i}`}
                className="group flex h-full flex-col justify-between bg-[#030712] p-8 lg:p-10 hover:bg-[#0F172A] transition-colors duration-400"
              >
                <div className="flex items-start justify-between">
                  <div className="grid h-16 w-16 place-items-center border border-white/15 font-display text-xl font-bold text-[#00D166] group-hover:border-[#00D166] transition-colors">
                    {m.initials}
                  </div>
                  <ArrowUpRight size={20} className="text-white/40 group-hover:text-[#00D166] transition-colors" />
                </div>
                <div className="mt-12">
                  <h3 className="font-display text-2xl font-bold text-white">{m.name}</h3>
                  <p className="font-body text-sm text-white/50 mt-1">{m.role}</p>
                  <span className="mt-4 inline-flex items-center gap-2 font-body text-xs text-white/60 group-hover:text-[#00D166] transition-colors">
                    <Linkedin size={14} /> View profile
                  </span>
                </div>
              </a>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
